import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import { installYandexMetrikaRouterTracking } from './services/yandexMetrika'

//import './css/main.css'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { installModatechAnalyticsContext } from './services/modatechAnalytics'
import { createYmaps } from 'vue-yandex-maps';

//let domain = 'http://mcbuy.mobileapp.alm.su/';
let domain = 'https://mobileapp.mcbuy.ru/';
window['domain'] = domain;

if (domain == 'https://mobileapp.mcbuy.ru/')
    window['yandex_apikey'] = '709aa718-3e61-40e8-82c9-bb07c107f918';
else
    window['yandex_apikey'] = '17e54920-400d-4fb2-8a1a-b3272d54afd0'

try {


    axios.defaults.headers.common['Authorization'] = 'Basic cHJvZml0OmtpdA==';
    axios.defaults.baseURL = domain;
    installModatechAnalyticsContext(axios);

    let device_uuid = (new Date()).getTime();
    if (localStorage.getItem('user-token'))
        device_uuid = localStorage.getItem('user-token');

    localStorage.setItem('user-token', device_uuid);

    window['app_start'] = false;
    let appStarting = false;
    document.addEventListener('deviceready', onDeviceReady, false);

    function onDeviceReady() {
        if (window['app_start'] || appStarting) {
            return;
        }

        appStarting = true;
        installYandexMetrikaRouterTracking(router);

        let this_device  = '';
        if (typeof device == 'object') {
            device_uuid = device.uuid;
            this_device = device;
            //axios.defaults.headers.common['Authorization'] = device.uuid;

            if (device.platform.indexOf("iOS") != -1) {
                if (device.model.indexOf("iPhone10") != -1
                    || device.model.indexOf("iPhone11") != -1
                    || device.model.indexOf("iPhone12") != -1
                    || device.model.indexOf("iPhone13") != -1
                    || device.model.indexOf("iPhone14") != -1
                    || device.model.indexOf("iPhone15") != -1
                    || device.model.indexOf("iPhone16") != -1
                    || device.model.indexOf("iPhone17") != -1)
                    document.body.classList.add('ios');
            }
        }

        const app2 = createApp(App, {device_uuid: device_uuid, device: this_device})
        app2.use(router)
        app2.use(store)
        app2.use(VueAxios, axios)
        app2.use(createYmaps({
            apikey: window['yandex_apikey'],
        }));
        app2.mount('#app')
        window['app_start'] = true;
    }

    const urlParams = new URLSearchParams(window.location.search);
// Получить конкретный параметр
    const paramValue = urlParams.get('dev');
   if (paramValue == 'Y')
    onDeviceReady();

    setTimeout(function () {
        if (window['app_start'] == false) {

            let form = new FormData();
            form.append("useragent", window.navigator.userAgent)
            form.append("date", new Date());
            form.append("error", 'Приложение не стартовало');
            let response = fetch(domain+'api/log/', {
                method: 'POST',
                body: form
            });
        }
    }, 2000)
}
catch (err) {
    let form = new FormData();
    form.append("useragent", window.navigator.userAgent)
    form.append("date", new Date());
    form.append("error", err);
    let response = fetch(domain+'api/log/', {
        method: 'POST',
        body: form
    });
}



